import { SidebarMenuItemModel, sidebarGuarderiaMenu, sidebarMenu } from '@/Shared/ui/navigation'

interface ManagedNavigationState {
  getSidebarMenu: () => SidebarMenuItemModel[]
}

export const useManagedNavigation = (isNursery: boolean): ManagedNavigationState => {
  const getSidebarMenu = (): SidebarMenuItemModel[] => {
    return isNursery ? sidebarGuarderiaMenu : sidebarMenu
  }

  return {
    getSidebarMenu,
  }
}
